<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">판매등록</span>
            <span class="txt">판매 상품을 결제 등록, 수정, 삭제 할 수 있습니다.</span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <span class="title">판매상품 설정</span>
                <div class="com-search-input">
                    <input
                        v-model="searchStr"
                        placeholder="이름, 연락처 입력"
                        type="text"
                        v-on:keyup.enter="onEventSearch"
                    />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
            <div class="line">
                <select-form
                    :select-data="['선택', '판매중', '판매중지']"
                    :select-value="['', 'true', 'false']"
                    :selected-value="saleYn"
                    @update:set="(val) => (saleYn = val)"
                ></select-form>
                <button class="com-search-reset" @click="resetSearchParams"></button>
            </div>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn blue" to="/madmin/sales/sell/edit">판매 등록</router-link>
                    <a class="com-btn blue" href="#" @click="createPop">상품 등록</a>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 130px" />
                    <col style="width: 500px" />
                    <col style="width: 170px" />
                    <col style="width: 170px" />
                    <col style="width: 125px" />
                    <col style="width: 145px" />
                    <col style="width: 185px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>
                            <button>등록일</button>
                        </th>
                        <th>
                            <button>상품명</button>
                        </th>
                        <th>
                            <button>공급가</button>
                        </th>
                        <th>
                            <button>판매가</button>
                        </th>
                        <th>
                            <button>재고수량</button>
                        </th>
                        <th>
                            <button>판매여부</button>
                        </th>
                        <th>관리</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- <tr>
                    <td>2019-12-25</td>
                    <td>요가복 상의 (핑크, XL)</td>
                    <td>16,000원</td>
                    <td>20,000원</td>
                    <td>5개</td>
                    <td>판매중</td>
                    <td>
                        <button class="com-btn blue" @click="modifyPop = true">수정</button>
                        <button class="com-btn red">삭제</button>
                    </td>
                </tr> -->
                    <tr v-for="i in itemList" :key="i.cc_center_prod_id">
                        <td>{{ i.cp_cre_dt | timestampFilter }}</td>
                        <td>{{ i.cp_namee }}</td>
                        <td>{{ i.cp_recv_price | numberFormatFilter }}원</td>
                        <td>{{ i.cp_sell_price | numberFormatFilter }}원</td>
                        <td v-if="i.cp_stoc_type_cd == 'U'">무제한</td>
                        <td v-else>{{ i.cp_stoc_total_cnt | numberFormatFilter }}개</td>
                        <td>{{ convertStock(i.cp_stoc_use_yn) }}</td>
                        <td>
                            <button class="com-btn blue" @click="onEditItem(i.cp_center_prod_id)">수정</button>
                            <button class="com-btn red" @click="onDeleteItem(i.cp_center_prod_id)">삭제</button>
                        </td>
                    </tr>
                    <tr v-if="itemList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
            <b-pagination
                v-model="pagingInfo.page"
                :per-page="pagingInfo.limit"
                :total-rows="pagingInfo.totalItems"
                align="center"
                aria-controls="my-table"
                first-class="first"
                last-class="last"
                next-class="next"
                prev-class="prev"
                @change="handlerPagenation($event)"
            ></b-pagination>
        </div>

        <!-- 상품등록 팝업 -->
        <div v-show="editPop" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="editPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">상품등록</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 295px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>
                                    상품명
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input v-model="productName" class="w400" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>공급가</th>
                                <td>
                                    <input
                                        v-model="recvPrice"
                                        class="w220"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onKeyUpPrice"
                                    />
                                    <span class="txt">원</span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    판매가
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <input
                                        v-model="sellPrice"
                                        class="w220"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onKeyUpPriceSell"
                                    />
                                    <span class="txt">원</span>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    재고수량
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="c-radio-pop-1-1"
                                                v-model="stockType"
                                                name="c-radio-pop-1"
                                                type="radio"
                                                value="U"
                                            />
                                            <label for="radio-pop-1-1">무제한</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="c-radio-pop-1-2"
                                                v-model="stockType"
                                                name="c-radio-pop-1"
                                                type="radio"
                                                value="L"
                                            />
                                            <label for="radio-pop-1-2">재고수량</label>
                                        </div>

                                        <input
                                            v-model="stockTotalCount"
                                            :disabled="stockType == 'U'"
                                            class="w60 center"
                                            type="text"
                                        />
                                        <span class="txt">개</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    판매여부
                                    <span class="imp">*</span>
                                </th>
                                <td>
                                    <div class="flex">
                                        <div class="com-radio">
                                            <input
                                                id="s-radio-pop-2-1"
                                                v-model="stockUseYn"
                                                name="s-radio-pop-2"
                                                type="radio"
                                                value="true"
                                            />
                                            <label for="s-radio-pop-2-1">판매중</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="s-radio-pop-2-2"
                                                v-model="stockUseYn"
                                                name="s-radio-pop-2"
                                                type="radio"
                                                value="false"
                                            />
                                            <label for="s-radio-pop-2-2">판매정지</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn" @click="editPop = false">취소</button>
                        <button class="com-btn blue" @click="onAddItem">등록</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- 상품수정 팝업 -->
        <div v-show="modifyPop" class="layer-pop square-type">
            <div class="view-content w655">
                <button class="close" @click="modifyPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">상품수정</span>
                    <table class="com-table left no-border">
                        <colgroup>
                            <col style="width: 200px" />
                            <col style="width: 295px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>상품명</th>
                                <td>
                                    <input v-model="productName" class="w400" type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>공급가</th>
                                <td>
                                    <input v-model="recvPrice" class="w220" type="text" />
                                    <span class="txt">원</span>
                                </td>
                            </tr>
                            <tr>
                                <th>판매가</th>
                                <td>
                                    <input v-model="sellPrice" class="w220" type="text" />
                                    <span class="txt">원</span>
                                </td>
                            </tr>
                            <tr>
                                <th>재고수량</th>
                                <td>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-1-1"
                                            v-model="stockType"
                                            name="radio-pop-1"
                                            type="radio"
                                            value="U"
                                        />
                                        <label for="radio-pop-1-1">무제한</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-1-2"
                                            v-model="stockType"
                                            name="radio-pop-1"
                                            type="radio"
                                            value="L"
                                        />
                                        <label for="radio-pop-1-2">재고수량</label>
                                    </div>
                                    <input
                                        v-model="stockTotalCount"
                                        :disabled="stockType == 'U'"
                                        class="w60 center"
                                        type="text"
                                    />
                                    <span class="txt">개</span>
                                </td>
                            </tr>
                            <tr>
                                <th>판매여부</th>
                                <td>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-2-1"
                                            v-model="stockUseYn"
                                            name="radio-pop-2"
                                            type="radio"
                                            value="true"
                                        />
                                        <label for="radio-pop-2-1">판매중</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            id="radio-pop-2-2"
                                            v-model="stockUseYn"
                                            name="radio-pop-2"
                                            type="radio"
                                            value="false"
                                        />
                                        <label for="radio-pop-2-2">판매정지</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="bottom-btn">
                        <button class="com-btn red" @click="onDeleteItemPop">삭제</button>
                        <button class="com-btn" @click="modifyPop = false">취소</button>
                        <button class="com-btn blue" @click="onEditItemPop">수정</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import EventBus from '../../../assets/js/eventBus';
import XLSX from 'xlsx';
import { numberFormat, timestampToDate } from '@/assets/js/excelCommon.js';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SalesSellEdit',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            editPop: false, // 상품등록 팝업
            modifyPop: false, // 상품수정 팝업
            pagingInfo: { ...pagingInfo },
            centerId: '',
            itemList: [],
            data: {},

            productName: '',
            recvPrice: '',
            sellPrice: '',
            stockType: '-',
            stockTotalCount: 0,
            stockUseYn: true,
            centerProductId: '',
            searchStr: '',

            saleYn: '',
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
        };
    },
    watch: {
        saleYn(newValue) {
            this.saleYn = newValue; // 새로운값;
            this.onSearchList();
        },
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        // 초기화
        async init() {
            // this.pagingInfo.page = 1;
            // this.pagingInfo.limit = 10;
            this.onSearchList();
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현
            const { data } = await this.getCenterListExcel(); // 엑셀용 요청값

            const excelDownloadArray = [];
            data.items.forEach((i) => {
                const temp = {};
                temp['등록일'] = timestampToDate(i.cp_cre_dt);
                temp['상품명'] = i.cp_namee;
                temp['공급가'] = numberFormat(i.cp_recv_price);
                temp['판매가'] = numberFormat(i.cp_sell_price);
                temp['재고수량'] = numberFormat(i.cp_stoc_total_cnt);
                temp['판매여부'] = this.convertStock(i.cp_stoc_use_yn);

                excelDownloadArray.push(temp);
            });
            /* [Key:value,...] */
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray); // 배열을 넣어야함.
            // cell width 설정
            const wscols = [{ wch: 12 }, { wch: 12 }, { wch: 20 }, { wch: 15 }, { wch: 10 }, { wch: 25 }];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '판매등록 아이템 리스트');
            XLSX.writeFile(wb, '판매등록_아이템_리스트.xlsx');
        },
        // 엑셀 다운로드를 위한 리스트
        getCenterListExcel() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/product`, {
                params: {
                    productname: this.searchStr,
                    stockUseYn: this.saleYn,
                    page: 1,
                    limit: 10000,
                },
            });
        },

        // 담당 상품 API 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                this.setPageParams(data);
                this.itemList = data.items;
                console.log('아이템리스트:', this.itemList);
                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 담당 상품 조회 API
        getCenterList() {
            // 스웨거 검색: 판매상품 페이징 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/uniform/product`, {
                params: {
                    productname: this.searchStr,
                    stockUseYn: this.saleYn,
                    ...this.pagingInfo,
                },
            });
        },
        convertStock(type) {
            if (type == true) {
                return '판매중';
            } else if (type == false) {
                return '판매중지';
            }
        },
        // 상품등록 호출
        async onAddItem() {
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                if (this.stockType == 'U') {
                    this.stockTotalCount = null;
                    console.log('stockType = 0');
                }
                const { data } = await this.postNewItem();
                console.log('등록되었습니다.', data);
                alert('등록되었습니다.');
                this.editPop = false;
                this.onSearchList();
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },

        // 상품등록 api
        postNewItem() {
            return api.post(`/admin/api/center/${this.centerId}/uniform/product`, {
                productName: this.productName,
                recvPrice: this.recvPrice ? this.getPureNumber(this.recvPrice) : 0,
                sellPrice: this.getPureNumber(this.sellPrice),
                stockType: this.stockType,
                stockTotalCount: this.stockTotalCount,
                stockUseYn: this.stockUseYn,
                onceType: 'R',
            });
        },

        // 상품수정
        async onEditItem(index) {
            try {
                this.modifyPop = true; // 수정팝업 호출
                console.log(index);
                this.centerProductId = index;
                const { data } = await this.editItem();
                console.log('===> Success edit centerList : ', data);

                if (this.stockType == 'U') data.stockTotalCount = null;

                this.productName = data.name;
                this.recvPrice = data.recvPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                this.sellPrice = data.sellPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                this.stockType = data.stockType;
                this.stockTotalCount = data.stockTotalCount;
                this.stockUseYn = data.stockUseYn;
                console.log(data.useYn);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 상품수정요청
        async onEditItemPop() {
            try {
                const { data } = await this.getEditItemPop();
                console.log('상품수정', data);
                alert('상품수정이 완료되었습니다.');
                this.modifyPop = false;
                this.onSearchList(); // 리스트 함수 호출
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        // 판매상품수정
        getEditItemPop() {
            return api.put(`/admin/api/center/${this.centerId}/uniform/product/${this.centerProductId}`, {
                productName: this.productName,
                recvPrice: this.recvPrice ? this.getPureNumber(this.recvPrice) : 0,
                sellPrice: this.getPureNumber(this.sellPrice),
                stockType: this.stockType,
                stockTotalCount: this.stockTotalCount,
                stockUseYn: this.stockUseYn,
                onceType: 'R',
            });
        },

        async onDeleteItem(index) {
            try {
                if (confirm('삭제하시겠습니까?') == true) {
                    this.centerProductId = index;
                    const { data } = await this.deleteItem();
                    console.log('삭제되었습니다.', data);
                    this.onSearchList(); // 리스트 함수 호출
                } else {
                    alert('삭제요청이 취소되었습니다.');
                    return false;
                }
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        async onDeleteItemPop() {
            try {
                if (confirm('삭제하시겠습니까?') == true) {
                    const { data } = await this.deleteItem();
                    console.log('삭제되었습니다.', data);
                    this.onSearchList(); // 리스트 함수 호출
                } else {
                    alert('삭제요청이 취소되었습니다.');
                    return false;
                }
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 수정상품조회
        editItem() {
            return api.get(`/admin/api/center/${this.centerId}/uniform/product/${this.centerProductId}`);
        },

        // 판매상품삭제
        deleteItem() {
            return api.delete(`/admin/api/center/${this.centerId}/uniform/product/${this.centerProductId}`);
        },

        // 판매상품등록을 위한 초기화
        createPop() {
            this.editPop = true;
            this.productName = '';
            (this.recvPrice = ''), (this.sellPrice = '');
            this.stockType = 'U';
            this.stockTotalCount = '';
            this.stockUseYn = 'true';
        },
        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },
        // 검색 조건 초기화
        resetSearchParams() {
            (this.saleYn = ''), this.onSearchList();
            EventBus.$emit('event:initList', 'init');
        },
        // 검색어 입력
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        // 파라미터 validate
        validateValues() {
            // 필수값 체크
            let result = false;
            const { productName, sellPrice, stockType, stockUseYn } = this;
            let msg = '';

            // 상품명
            if (productName === '' || productName === undefined) {
                msg = '상품명을 입력하세요.';
                return { result, msg };
            }
            // 판매가
            if (sellPrice === '' || sellPrice === undefined) {
                msg = '판매가를 입력하세요.';
                return { result, msg };
            }
            // 재고수량
            if (stockType === '' || stockType === undefined) {
                msg = '재고수량을 선택하세요.';
                return { result, msg };
            }
            // 판매여부
            if (stockUseYn === '' || stockUseYn === undefined) {
                msg = '판매여부를 선택하세요.';
                return { result, msg };
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },
        getNumberFormat(num) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        onKeyUpPrice() {
            // 결제 금액 업데이트(공급가)
            const num = this.getPureNumber(this.recvPrice);
            this.recvPrice = this.getNumberFormat(num);
        },
        onKeyUpPriceSell() {
            // 결제 금액 업데이트(판매가)
            const num = this.getPureNumber(this.sellPrice);
            this.sellPrice = this.getNumberFormat(num);
        },
        getPureNumber(num) {
            if (typeof num !== 'string' || num === undefined || num === '') {
                return num;
            }
            return parseInt(num.toString().replace(/[,-]/g, ''));
        },
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
    },
};
</script>
<style lang="scss"></style>
